import practiceImg from "@/assets/caregiver-team.jpg";

const FounderSection = () => (
  <section className="py-24 md:py-32 bg-background">
    <div className="container">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-16 items-center max-w-6xl mx-auto">
        <div className="md:col-span-2">
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-border shadow-sm">
            <img
              src={practiceImg}
              alt="Kinship Care Collective companion concierges supporting an older adult at home in Nashville"
              className="w-full h-full object-cover object-top"
              width={800}
              height={800}
              loading="lazy"
            />
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink mb-4 font-medium">Our Practice</p>
          <h2 className="text-3xl md:text-5xl font-heading font-semibold mb-6 leading-[1.1]">A Practice Built on Belief</h2>
          <div className="w-12 h-px bg-warm mb-8" />
          <p className="text-foreground/85 text-lg md:text-xl font-light leading-relaxed mb-6">
            Kinship Care Collective was built for the families who want their parents cared for the way they would care for
            them themselves. That means the same trusted companion each week, real relationship, gentle activity, and the
            dignity every older adult deserves. Nothing rushed. Nothing outsourced. Nothing generic.
          </p>
          <p className="text-muted-foreground text-sm">
            A boutique, non-medical companion care practice serving Nashville, Davidson and Williamson County.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default FounderSection;